import insta from './social/insta.gif'
import git from './social/icons8-github.gif'
import linkedin from './social/linkedin.gif'
import twitter from './social/icons8-twitter-squared.gif'


const socialImages = [
    {
        "title": "instagram",
        "url": insta,
        "url2": "https://www.instagram.com/ohhhmohit_/",
      },
      {
        "title": "github",
        "url": git,
        "url2": "https://github.com/hackwhiz-8",
      },
      {
        "title": "Linkendin",
        "url": linkedin,
        "url2": "https://www.linkedin.com/in/mohit-s-3747a31ba/",
      },
      {
        "title": "twitter",
        "url": twitter,
        "url2": "https://www.instagram.com/ohhhmohit_/",
      }
      
]

export default socialImages;